<template>
    <b-container fluid class="img-bg">
        <b-row no-gutters>
            <b-col sm class="header-column">
                <AdminBar title="Napoli Sotterranea Tour"></AdminBar>
            </b-col>
        </b-row>
        <b-row no-gutters class="mainrow">
            <b-col xl="1">
            </b-col>
            <b-col lg class="tour-column">
                <div class="panel tourbox" style="height:50px;">
                    <b-button v-b-toggle.atbxsidebar class="help" size="sm" variant="success"><b-icon-gear></b-icon-gear></b-button>
                    <b-button-toolbar style="float:right;" >
                        <b-button-group class="mx-1">
                            <b-button size="sm" @click="prev" variant="success">&laquo;</b-button>
                        </b-button-group>
                        <b-button-group class="mx-1">
                            <b-button size="sm" @click="next" variant="success">&raquo;</b-button>
                        </b-button-group>
                    </b-button-toolbar>
                    <b-form-checkbox v-model="syncview" variant="success" style="float:right;line-height:25px;margin-top:3px;" >Sincronizza Viste</b-form-checkbox>
                    <div style="width: 50%; margin:0 auto">
                        {{currentnode}}
                        <b-dropdown size="sm" variant="success" boundary="viewport">
                            <b-dropdown-item v-for="node in nodes" :key="node.id" @click="goto(node.id)">{{node.title}}</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <div class="panel tour-container">
                    <div id="tour-div">
                        <marzipano-viewer ref="pano_view" :width="500" :height="600" :tour_folder="folder" tour_xml="pano.xml" @sync-nav="syncNav" @sync-view="syncView" @panoready="panoIsReady"></marzipano-viewer>
                    </div>
                </div>
            </b-col>
            <b-col lg="2" class="sidebar">
                <div class="panel">
                    <count-down ref="countdown" :target="timeTarget" :deadline="timeTracker" ></count-down>
                    <b-button-toolbar justify size="sm">
                        <b-button-group class="mx-1">
                            <b-button @click="startTour" size="sm" variant="success" :disabled="isStreaming()">Avvia Tour</b-button>
                        </b-button-group>
                        <b-button-group class="mx-1">
                            <b-button @click="endTour" size="sm" variant="success" :disabled="!isStreaming()">Termina Tour</b-button>
                        </b-button-group>
                    </b-button-toolbar>

                </div>
                <chat-box ref="chatbox" @message="sendChatMessage" :username="currentUserRole.nome" class="chatbox panel"></chat-box>
            </b-col>
            <b-col lg="2" class="sidebar-user">
                <b-list-group-item class="panel">
                    <div class="w-100">
                        <div id="local_stream" ></div>
                    </div>
                </b-list-group-item>
                <div class="panel">
                    <div>Utenti:</div>
                    <UserList ref="userlist" @usercohost="userStartCoHost" @stopusercohost="userStopCoHost" host></UserList>
                </div>
            </b-col>
            <b-col xl="1">
            </b-col>
        </b-row>
        <b-sidebar id="atbxsidebar" title="Strumenti" bg-variant="dark" text-variant="light" shadow width="500px">
            <div class="agora_toolbox">
                <Agora_RTM ref="artm" :username="agora_uid" :channel="channel" :ishost="showcontrols" autoconnect @command="onCommand" @publishmembers="connectRTC" @memberJoin="memberJoin" @memberLeft="memberLeft"></Agora_RTM>
                <Agora_RTC ref="artc" :username="agora_uid" :channel="channel" :ishost="showcontrols" video @stream-started="registerstream" @stream-stopped="unregisterstream" @rtc-connected="startStream" @local-stream-started="playlocalstream"></Agora_RTC>
            </div>
        </b-sidebar>
    </b-container>
</template>

<script>
    import {mapGetters} from "vuex";

    import moment from "moment";
    moment.locale('IT');

    import countDown from './countdown';

    import AdminBar from "./AdminBar";
    import Agora_RTM from './Agora_RTM';
    import Agora_RTC from './Agora_RTC';
    import marzipanoViewer from "./marzipanoViewer";
    import ChatBox from "./ChatBox";
    import UserList from "./UserList";

    export default {
        name: "Host",
        props: ['channel', 'folder'],
        components: {
            AdminBar,
            marzipanoViewer,
            Agora_RTM,
            Agora_RTC,
            countDown,
            ChatBox,
            UserList
        },
        data: function () {
            return {
                syncview: false,
                timeTracker: null,
                timeTarget: 40,
                showcontrols: true,
                nodes: null,
                currentnode: ''
            }
        },
        computed: {
            // mix the getters into computed with object spread operator
            ...mapGetters([
                'currentUserRole'
            ]),
            agora_uid: function () {
                return '$' + this.currentUserRole.nome + '#' + this.channel;
            },
        },
        methods: {
            onCommand: function(_json_command){
                if(Object.prototype.hasOwnProperty.call(_json_command, 'command')) {
                    if (_json_command.command === 'CHAT') {
                        this.$refs.chatbox.pushMessage(_json_command);
                    } else if (_json_command.command === 'HOST') {
                        this.$refs.userlist.setUserNotification(_json_command.user);
                    }
                }
            },
            syncNav: function (_payload) {
                _payload.command='NAV';
                this.$refs.artm.sendCommand(_payload);
            },
            syncView: function (_payload) {
                if (this.syncview) {
                    _payload.command='VIEW';
                    this.$refs.artm.sendCommand(_payload);
                }
            },
            next: function () {
                this.currentnode = this.$refs.pano_view.pano_gotonextnode();
                //console.log(this.$refs.pano_view.pano_gotonextnode());
            },
            prev: function () {
                this.currentnode = this.$refs.pano_view.pano_gotoprevnode();
                //console.log(this.$refs.pano_view.pano_gotoprevnode());
            },
            goto: function(_node) {
                // this.currentnode = _node;
                this.currentnode = this.$refs.pano_view.pano_gotonode(_node);
            },
            toggleSyncView(_value) {
                this.syncview = _value;
            },
            sendChatMessage(_message) {
                let chatmessage = _message;
                chatmessage.command = 'CHAT';
                this.$refs.artm.sendCommand(chatmessage)
            },
            connectRTC (_members){
                this.$refs.userlist.setUsersOffline();
                for(const m of _members) {
                    if(m !== this.agora_uid){
                        this.$refs.userlist.addUser(m, m.split('#')[0]);
                    }
                }
            },
            memberJoin(_id){
                console.log('++++++++++++++++++++++++', _id);
                if(_id !== this.agora_uid){
                    this.$refs.userlist.addUser(_id, _id.split('#')[0]);
                }
            },
            memberLeft(_id){
                console.log('------------------------', _id);
                this.$refs.userlist.setUserOffline(_id);
            },
            userStartCoHost (_userId, _selected){
                this.$refs.artm.sendCommand({command:'STARTUSERCOHOST', key:_userId, enable:_selected});
            },
            userStopCoHost (_userId, _selected){
                this.$refs.artm.sendCommand({command:'STOPUSERCOHOST', key:_userId, enable:_selected});
            },
            startTour() {
                if(!this.$refs.artc.isStreaming()){
                    this.$refs.artm.sendCommand({command:'CONNECT'});
                    this.$refs.artc.connectChannel();
                    this.$refs.countdown.start();

                    if (!this.timeTracker){
                        localStorage.started = new moment().add(40, 'm').format('YYYY-MM-DD HH:mm:ss');
                    }
                }
            },
            endTour() {
                this.$refs.artc.stopStream();
                this.$refs.countdown.pause();
                this.$refs.artm.sendCommand({command:'ENDTOUR'});
            },
            startStream(){
                this.$refs.artc.startStream();
            },
            registerstream: function(_stream) {
                this.$refs.userlist.setUserStreaming(_stream);
            },
            unregisterstream: function(_stream) {
                this.$refs.userlist.setUserStreaming(_stream, false);
            },
            playlocalstream: function(_localstream) {
                // empty local_stream
                const div = document.querySelector('#local_stream');
                [].slice.call(div.children).forEach(function(child) {div.removeChild(child)})
                _localstream.play("local_stream");
            },
            resizePanorama(){
                this.$nextTick(() => {
                    if(this.$refs.pano_view){
                        const div = document.querySelector('#tour-div');
                        this.$refs.pano_view.setSize(div.clientWidth, div.clientHeight);
                    }
                })
            },
            panoIsReady(){
                this.resizePanorama();
                this.nodes = this.$refs.pano_view.pano_getNodesInfo();
                this.currentnode = this.$refs.pano_view.pano_getCurrentNode();
            },
            isStreaming: function() {
                if(this.$refs.artc){
                    return this.$refs.artc.isStreaming();
                }
                return false;
            }
        },
        created() {
            if (localStorage.started) {
                if (new moment(localStorage.started).diff(moment(), 'minutes') > 0){
                    this.timeTracker = localStorage.started;
                    console.log('previous time loaded');
                }
            }
        },
        mounted(){
            this.$nextTick(() => {
                window.addEventListener('resize', this.resizePanorama);

            })
        },
        updated(){
            this.$nextTick(() => {
                this.resizePanorama();
            })
        }
    }
</script>

<style scoped>

    #tour-div{
        height:98%;
        width:95%;
        margin:auto;
    }

    #atbxsidebar{
        background-color: slategray;
    }

    .header-column{
        margin-top:1.5%;
        margin-bottom:1.5%;
    }

    .tour-column {
        max-width:1024px;
        max-height:768px;
        min-width:300px;
        min-height:300px;
    }

    .tour-container {
        height:calc(100% - 60px);
    }

    .panel{
        overflow:hidden;
        background-color:#fff;
        margin:3px;
        padding:5px;
        border-radius:5px;
    }

    .tourbox{
        padding: 10px;
    }

    .img-bg{
        background-image: url("../../public/ns_bg.jpg");
        background-size: cover;
        background-position: center;
        padding:0;
        height:100%;
        overflow:auto;
    }

    .mainrow{
        min-height: 300px;
        height: 75%;
        padding: 0 10px 0 10px;
    }

    .chatbox{
        height: 75%;
        max-height: 75%;
    }

    .help{
        float:left;
    }

    .agora_toolbox{
        position:absolute;
        bottom:10px;
    }

    .sidebar{
        overflow: hidden;
        max-height: 100%;
        max-width: 25%;
        min-width: 250px;
        min-height: 400px;
    }

    .sidebar-user{
        overflow: hidden;
        max-height: 100%;
        max-width: 15%;
        min-width: 200px;
        min-height: 400px;
    }

    .footer{
        position:absolute;
        bottom:10px;
        width:100%;
        height:50px;
        background-color: #fff;
        margin-top:1%;
    }

    /deep/ video {
        position: unset !important;
    }

    @media screen and (max-width: 992px) {
        .header-column{
            margin-top:0;
            margin-bottom:5px;
        }

        .sidebar{
            width:45%;
            max-width: 50%;
        }

        .sidebar-user{
            width:45%;
            max-width: 50%;
        }
        .mainrow{
            height:50%;
            padding:0;
        }
    }

    @media screen and (max-width: 400px) {
        .header-column{
            margin-top:0;
            margin-bottom:2px;
        }

        .sidebar{
            width:100%;
            max-width: 100%;
        }

        .sidebar-user{
            width: 100%;
            max-width: 100%;
        }

    }

</style>
